<template>
  <div class="loan">
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">

      
    </div>
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please Try again later.
      </va-notification>
    </div>
  	<div class="row">
      <div class="flex s12 md9">
      	 <va-card :title="$t('crmListCRMs')">
      	 	<template slot="actions">           
	            <va-button icon="fa fa-close" @click="$router.go(-1)">Cancel</va-button>	           
	        </template>
          <va-input
          class="ma-0"
          :value="term"
          :placeholder="$t('Search  by description or status')"
          @input="search"
          removable
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
          <va-data-table
      :fields="mode ? detailedFields : fields"
      :data="filteredData"
      :loading="loading"
      hoverable
    >
      <template slot="icon">
        <va-icon name="fa fa-list" color="secondary" />
      </template>
      <template v-slot:code="props">
        {{ props.rowData.code }}
      </template>
      <template v-slot:descripton="props">
        {{ props.rowData.descripton  }}
      </template>
      <template v-slot:type="props">
        {{ props.rowData.type}}
      </template>
      <template v-slot:status="props">
        {{ props.rowData.status}}
      </template>

     

    </va-data-table>
      	 </va-card>
      </div>
    </div>
  
  </div>
</template>
<script src="https://unpkg.com/vue@2.5.13/dist/vue.js"></script>
<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'
import debounce from 'lodash/debounce'

export default {
  components: {
    ...spinners      
  },
  name: 'loan',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),   
      loan_no : this.$route.params.loan_no,
      loading: false,
      term: null,
      loadSelect:false,
   
      details:{},
  
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

fields () {
      return [{
        name: '__slot:icon',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: '__slot:code',
        title: this.$t('CRM Number'),
        width: '30%',
        sortField: 'amount',
      }, 
      {
        name: '__slot:descripton',
        title: this.$t('Description'),
        width: '50%',
        sortField: 'amount',
      },
      {
        name: '__slot:type',
        title: this.$t('Contacted for'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:status',
        title: this.$t('Status'),
        width: '20%',
        sortField: 'amount',
      },
   
]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.details
      }
      console.log(this.term);
      return this.details.filter(item => {
        return item.descripton.toLowerCase().startsWith(this.term.toLowerCase()) || item.status.toLowerCase().startsWith(this.term.toLowerCase())
       
      })
    },
    formReady () {

     },      
  },
  methods : {
    GetProduct(id) {      
      return this.loans.filter(item => item.loanType.toLowerCase() === this.id.toLowerCase());      
    },
    
 
    onsubmit () {

    },

    GetCRMListing () {
      this.loadSelect = true
      this.loading = true
      const self = this
      const form = {
  user:this.userData.user_id,
  phonenumber: this.userData.mobile_number
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}ListCRMMember`, form, config)
      .then(function (res) {

          self.loadSelect = false
          self.loading = false
          res = res.data
          self.details =  res.slice().reverse()

      })
      .catch(function (error) {
          console.log(error)
      })
    },
    search: debounce(function (term) {
      console.log(term)
      this.term = term
    }, 400),

  },
  created () { 
    this.GetCRMListing();
   
 
  }
}
</script>